
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import BackButton from "@/components/BackButton.vue";

const namespace = "PostModule";

@Component({
  components: {
    BackButton
  },
  metaInfo:{
    title: "Pau Roselló - Contact"
  }
})

export default class Contact extends Vue{
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }
  
};
